import { defineStore } from 'pinia'
import type { ArticleStateModel, AssignedModelListItem } from '@/api/t1/model/articleModel'
import type { ICatalogShipmentWindowRange, SellerColorModel } from '@/api/t1/model/catalog'
import type { MasterSizeScaleModel, SizeScaleModel } from '@/api/t1/model/sizeModel'
import type Article from '@/models/article'
import type DropReason from '@/models/dropReason'
import type { IDatasetValuesModel } from '@/api/t1/model/datasetDetailsModel'

interface LookupMasterData {
  catalogModels: Record<number, AssignedModelListItem> | null
  sizeScales: Record<number, SizeScaleModel> | null
  masterSizeScales: Record<number, MasterSizeScaleModel> | null
  retailWindows: Record<number, ICatalogShipmentWindowRange> | null
  articleStates: Record<number, ArticleStateModel> | null
  colors: Record<number, SellerColorModel> | null
  articles: Record<number, Article> | null
  sellerModels: Record<number, Article> | null
  linkedCatalogArticles: Record<number, Article> | null
  dropReasons: Record<number, DropReason> | null
  datasetValues: Record<number, Record<number, IDatasetValuesModel>> | null
}

export const useAdminStore = defineStore({
  id: 'adminStore',
  state: () => ({
    lastUsedFile: null as File | null,
    lookupData: {} as LookupMasterData,
  }),
  actions: {
    setLastUsedFile(file: File) {
      this.lastUsedFile = file
    },
  },
})
